// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

// Testimonial slider — opacity crossfade, no height jump.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.testimonial-slider').forEach(function (slider) {
      var track = slider.querySelector('.js-testimonial-track');
      if (!track) return;
      // Only direct .field__item children — avoids picking up nested field items.
      var fieldItems = track.querySelector('.field__items');
      var items = fieldItems
        ? Array.from(fieldItems.querySelectorAll(':scope > .field__item'))
        : Array.from(track.querySelectorAll(':scope > .field__item'));
      if (items.length < 2) return;
      var dotsWrap = slider.querySelector('.js-testimonial-dots');
      var current = 0;

      track.classList.add('js-slider-init');
      items[0].classList.add('active');

      items.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
      });

      function goTo(idx) {
        if (idx === current) return;
        var dots = dotsWrap.querySelectorAll('.dot');
        items[current].classList.remove('active');
        dots[current].classList.remove('active');
        current = idx;
        items[current].classList.add('active');
        dots[current].classList.add('active');
      }

      setInterval(function () { goTo((current + 1) % items.length); }, 5000);
    });
  });
}());

// Core Values slider — crossfade; dots live inside each slide's text panel.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.core-values-slider').forEach(function (slider) {
      var track = slider.querySelector('.js-cv-track');
      if (!track) return;

      // Only direct .field__item children — avoids picking up nested field items
      // inside each slide (e.g. the image field's own .field__item wrappers).
      var fieldItems = track.querySelector('.field__items');
      var items = fieldItems
        ? Array.from(fieldItems.querySelectorAll(':scope > .field__item'))
        : Array.from(track.querySelectorAll(':scope > .field__item'));
      if (items.length < 2) return;

      var current = 0;
      track.classList.add('js-slider-init');
      items[0].classList.add('active');

      // Build identical dot sets inside every slide's .js-cv-dots container
      items.forEach(function (item, i) {
        var dotsWrap = item.querySelector('.js-cv-dots');
        if (!dotsWrap) return;
        items.forEach(function (_, j) {
          var dot = document.createElement('button');
          dot.className = 'dot' + (j === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (j + 1));
          dot.addEventListener('click', function () { goTo(j); });
          dotsWrap.appendChild(dot);
        });
      });

      function goTo(idx) {
        if (idx === current) return;
        idx = (idx + items.length) % items.length;
        items[current].classList.remove('active');
        items[idx].classList.add('active');
        // Sync all dot sets
        slider.querySelectorAll('.js-cv-dots').forEach(function (wrap) {
          wrap.querySelectorAll('.dot').forEach(function (dot, di) {
            dot.classList.toggle('active', di === idx);
          });
        });
        current = idx;
      }

      var timer = setInterval(function () { goTo(current + 1); }, 6000);
      slider.addEventListener('mouseenter', function () { clearInterval(timer); });
      slider.addEventListener('mouseleave', function () {
        timer = setInterval(function () { goTo(current + 1); }, 6000);
      });

      // Touch swipe support for mobile.
      var touchStartX = 0;
      var touchStartY = 0;
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        // Only act on predominantly horizontal swipes of at least 40px.
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
        clearInterval(timer);
        goTo(dx < 0 ? current + 1 : current - 1);
        timer = setInterval(function () { goTo(current + 1); }, 6000);
      }, { passive: true });
    });
  });
}());

// Hide .navbar-top on scroll down, reveal on scroll up.
// Uses explicit state + cooldown to prevent layout-reflow oscillation.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.navbar-top');
    if (!bar) return;

    var hidden    = false;
    var lastY     = window.scrollY;
    var ticking   = false;
    var cooldown  = false;
    var THRESHOLD = 10;   // min px delta to act
    var COOLDOWN  = 250;  // ms to ignore scroll after a state change

    function setState(hide) {
      if (hide === hidden) return;
      hidden = hide;
      cooldown = true;
      bar.style.maxHeight = hidden ? '0' : '';
      setTimeout(function () { cooldown = false; }, COOLDOWN);
    }

    window.addEventListener('scroll', function () {
      if (ticking || cooldown) return;
      ticking = true;
      requestAnimationFrame(function () {
        var currentY = window.scrollY;
        var delta    = currentY - lastY;

        if (Math.abs(delta) >= THRESHOLD) {
          if (delta > 0 && currentY > 60) {
            setState(true);
          } else if (delta < 0) {
            setState(false);
          }
          lastY = currentY;
        }
        ticking = false;
      });
    }, { passive: true });
  });
}());

// Split-feature gradient: span white→#F2F2F5 per group of adjacent LB blocks only.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var sections = Array.from(document.querySelectorAll('.split-feature'));
    if (sections.length === 0) return;

    /**
     * Start a new group when the previous and current sections are not
     * in consecutive block wrappers (e.g. hero/text between split-features).
     */
    function breaksGroup(prevSection, currSection) {
      var w1 = prevSection.parentElement;
      var w2 = currSection.parentElement;
      if (!w1 || !w2) return true;
      // Bare sections as direct siblings (same parent).
      if (w1 === w2) {
        return prevSection.nextElementSibling !== currSection;
      }
      if (w1.parentElement !== w2.parentElement) return true;
      return w1.nextElementSibling !== w2;
    }

    var groups = [];
    var group = [sections[0]];
    for (var i = 1; i < sections.length; i++) {
      if (breaksGroup(sections[i - 1], sections[i])) {
        groups.push(group);
        group = [];
      }
      group.push(sections[i]);
    }
    groups.push(group);

    groups.forEach(function (g) {
      var total = g.length;
      g.forEach(function (el, idx) {
        el.dataset.sfIndex = String(idx);
        el.dataset.sfTotal = String(total);
        delete el.dataset.sfMiddle;
        delete el.dataset.sfLast;
        if (total > 2 && idx > 0 && idx < total - 1) {
          el.dataset.sfMiddle = '1';
        }
        if (idx === total - 1) {
          el.dataset.sfLast = '1';
        }
      });
    });
  });
}());

// Research Initiatives — align grid and heading with the page .container.
// Uses JS because Layout Builder regions can add unpredictable extra offsets.
(function () {
  function alignRI() {
    var ri = document.querySelector('.research-initiatives');
    if (!ri) return;

    // Inject a temporary .container in normal flow (height:0) so Bootstrap's
    // margin:auto centering applies correctly, then read its content edge.
    var sentinel = document.createElement('div');
    sentinel.className = 'container';
    sentinel.style.cssText = 'height:0;overflow:hidden;visibility:hidden;pointer-events:none;';
    ri.insertBefore(sentinel, ri.firstChild);

    var sentRect = sentinel.getBoundingClientRect();
    var innerPad = parseFloat(getComputedStyle(sentinel).paddingLeft) || 0;
    var riLeft   = ri.getBoundingClientRect().left;
    var offset   = (sentRect.left - riLeft) + innerPad;

    ri.removeChild(sentinel);

    var gridOuter = ri.querySelector('.research-initiatives__grid-outer');
    var heading   = ri.querySelector('.research-initiatives__heading');
    if (gridOuter) gridOuter.style.paddingLeft = offset + 'px';
    if (heading)   heading.style.paddingLeft   = offset + 'px';
  }

  document.addEventListener('DOMContentLoaded', alignRI);
  window.addEventListener('resize', alignRI);
}());

// Event related slider starts with the first card partially off-screen, while
// keeping the full card accessible by scrolling back to the left.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.event-full__related-outer').forEach(function (el) {
      var content = el.querySelector('.view-events .view-content');
      if (!content || content.children.length < 4) return;

      el.scrollLeft = window.matchMedia('(max-width: 767px)').matches
        ? Math.round(window.innerWidth * 0.6)
        : 150;
    });
  });
}());

// Research Initiatives — drag-to-scroll the horizontal grid.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.research-initiatives__grid-outer').forEach(function (el) {
      var startX = 0;
      var scrollLeft = 0;
      var dragging = false;

      el.addEventListener('mousedown', function (e) {
        dragging = true;
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
        el.classList.add('is-dragging');
      });

      document.addEventListener('mouseup', function () {
        dragging = false;
        el.classList.remove('is-dragging');
      });

      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        var x = e.pageX - el.offsetLeft;
        var walk = (x - startX) * 1.2;
        el.scrollLeft = scrollLeft - walk;
      });

      // Touch support
      el.addEventListener('touchstart', function (e) {
        startX = e.touches[0].pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      }, { passive: true });

      el.addEventListener('touchmove', function (e) {
        var x = e.touches[0].pageX - el.offsetLeft;
        var walk = (x - startX) * 1.2;
        el.scrollLeft = scrollLeft - walk;
      }, { passive: true });

      // Prevent click events firing on child links after a drag
      el.addEventListener('click', function (e) {
        if (Math.abs(el.scrollLeft - scrollLeft) > 5) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });
  });
}());

// Research Initiatives — slow drift-scroll on hover based on mouse position.
// Left half of the container drifts left; right half drifts right.
// Speed scales linearly from 0 at the centre to MAX_SPEED at the edges.
// Pauses while the user is drag-scrolling.
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.research-initiatives__grid-outer').forEach(function (el) {
      var rafId  = null;
      var mouseX = 0;
      var MAX_SPEED = 4; // px per animation frame at the outermost edge

      function tick() {
        if (!el.classList.contains('is-dragging')) {
          var rect   = el.getBoundingClientRect();
          var relX   = mouseX - rect.left;
          var half   = rect.width / 2;
          // normalised distance from centre: -1 (far left) → +1 (far right)
          var norm   = (relX - half) / half;
          norm = Math.max(-1, Math.min(1, norm));
          var speed  = norm * MAX_SPEED;

          if (speed !== 0) {
            el.scrollLeft += speed;
          }
        }
        rafId = requestAnimationFrame(tick);
      }

      el.addEventListener('mouseenter', function (e) {
        mouseX = e.clientX;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(tick);
      });

      el.addEventListener('mousemove', function (e) {
        mouseX = e.clientX;
      });

      el.addEventListener('mouseleave', function () {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      });
    });
  });
}());

// Mobile menu: tapping the link text navigates; tapping the chevron toggles
// the submenu. An invisible <span> is absolutely positioned over the chevron
// area so it catches those taps independently of the link — no clientX math,
// no Bootstrap interference, no visual change.
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var mobileMenu = document.querySelector('.mobile-menu');
    if (!mobileMenu) return;

    mobileMenu.querySelectorAll('.nav-item.dropdown').forEach(function (item) {
      var link = item.querySelector(':scope > .nav-link.dropdown-toggle');
      var menu = item.querySelector(':scope > .dropdown-menu');
      if (!link || !menu) return;

      // ── ① Strip Bootstrap's dropdown behaviour from the parent link ─────
      // cloneNode does not copy event listeners, so Bootstrap's click handler
      // (which calls preventDefault and opens the dropdown) is gone. The link
      // then behaves like a plain <a> and navigates on click.
      var cleanLink = link.cloneNode(true);
      cleanLink.removeAttribute('data-bs-toggle');
      cleanLink.removeAttribute('data-bs-auto-close');
      item.replaceChild(cleanLink, link);
      link = cleanLink;

      // ── ② Invisible tap target over the chevron — Bootstrap ignores it ──
      // Because the span has no data-bs-toggle, Bootstrap's delegation never
      // fires; we manage show/hide entirely ourselves.
      var tap = document.createElement('span');
      tap.className = 'mobile-menu__chevron-tap';
      tap.setAttribute('aria-hidden', 'true');
      item.appendChild(tap);

      tap.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = menu.classList.contains('show');

        // Collapse all other open submenus
        mobileMenu.querySelectorAll('.nav-item.dropdown').forEach(function (other) {
          if (other === item) return;
          var otherMenu = other.querySelector(':scope > .dropdown-menu');
          var otherLink = other.querySelector(':scope > .nav-link.dropdown-toggle');
          if (otherMenu) otherMenu.classList.remove('show');
          if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
        });

        menu.classList.toggle('show', !isOpen);
        link.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // Reset submenus when the offcanvas drawer closes
    var offcanvasEl = mobileMenu.closest('.offcanvas') || mobileMenu;
    offcanvasEl.addEventListener('hide.bs.offcanvas', function () {
      mobileMenu.querySelectorAll('.dropdown-menu.show').forEach(function (m) {
        m.classList.remove('show');
      });
      mobileMenu.querySelectorAll('.nav-link[aria-expanded="true"]').forEach(function (l) {
        l.setAttribute('aria-expanded', 'false');
      });
    });
  });
}());

// Desktop nav: open dropdown on hover + allow parent link click to navigate.
// Bootstrap intercepts clicks on [data-bs-toggle="dropdown"] and prevents
// the default anchor navigation. On desktop (≥ 992px) we re-enable navigation
// and rely on CSS :hover to open/close the panel instead.
(function () {
  function isDesktop() {
    return window.innerWidth >= 992;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var mainNav = document.querySelector('.navbar--main');
    if (!mainNav) return;

    // Allow parent-link clicks to navigate on desktop
    mainNav.querySelectorAll('.nav-item.dropdown > .nav-link.dropdown-toggle').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (isDesktop() && this.href && this.href !== '#' && !this.href.endsWith('#')) {
          e.stopImmediatePropagation(); // beat Bootstrap's listener
          e.preventDefault();
          window.location.href = this.href;
        }
      }, true); // capture phase – runs before Bootstrap's bubble handler
    });

    // Close open dropdown when mouse leaves the whole nav-item on desktop
    mainNav.querySelectorAll('.nav-item.dropdown').forEach(function (item) {
      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        var menu = item.querySelector('.dropdown-menu');
        var toggle = item.querySelector('.dropdown-toggle');
        if (menu && menu.classList.contains('show')) {
          menu.classList.remove('show');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          item.classList.remove('show');
        }
      });

      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        var menu = item.querySelector('.dropdown-menu');
        var toggle = item.querySelector('.dropdown-toggle');
        if (menu && !menu.classList.contains('show')) {
          menu.classList.add('show');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
          item.classList.add('show');
        }
      });
    });
  });
}());

// Publications — sync selects with URL params and autosubmit via AJAX.
(function () {
  function syncSelectsFromUrl() {
    var params = new URLSearchParams(window.location.search);
    document.querySelectorAll('.publications-filter-bar__inner select').forEach(function (sel) {
      var param = params.get(sel.name);
      if (param !== null) {
        sel.value = param;
      }
    });
  }

  // Sync on initial load.
  document.addEventListener('DOMContentLoaded', syncSelectsFromUrl);

  // Re-sync after Drupal AJAX completes (form may be re-rendered).
  document.addEventListener('drupalAjaxSuccess', syncSelectsFromUrl);

  // Event delegation — survives DOM replacement by AJAX.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.closest || !sel.closest('.publications-filter-bar__inner')) return;
    if (sel.tagName !== 'SELECT') return;

    var form = sel.closest('form');
    if (!form) return;

    var submitBtn = form.querySelector(
      '[data-drupal-selector="edit-submit-publications"], button[type="submit"], input[type="submit"]'
    );
    if (submitBtn) {
      submitBtn.click();
    } else {
      form.submit();
    }
  });
}());

// Publications — hide duplicate group titles after load-more appends new rows.
(function () {
  function dedupeGroupTitles(wrapper) {
    if (!wrapper) return;
    var lastSeen = null;
    wrapper.querySelectorAll('.publication-group-title').forEach(function (el) {
      var text = el.textContent.trim();
      if (text === lastSeen) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
        lastSeen = text;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.views-infinite-scroll-content-wrapper');
    if (!wrapper) return;

    dedupeGroupTitles(wrapper);

    // Re-run whenever infinite scroll appends new nodes.
    var observer = new MutationObserver(function () {
      dedupeGroupTitles(wrapper);
    });
    observer.observe(wrapper, { childList: true, subtree: false });
  });
}());

// ── Hero Video: play/pause toggle ──────────────────────────────────────────────
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hero-video]').forEach(function (section) {
      var video    = section.querySelector('.hero-video__bg');
      var btn      = section.querySelector('[data-hero-video-toggle]');
      var isAutoplay = section.hasAttribute('data-autoplay');
      if (!video) return;

      function updateState() {
        var playing = !video.paused;
        section.classList.toggle('is-playing', playing);
        if (btn) {
          btn.classList.toggle('is-playing', playing);
          btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        }
      }

      // Sound toggle (mute/unmute)
      var soundBtn = section.querySelector('[data-hero-video-sound]');
      function updateSoundState() {
        if (!soundBtn) return;
        var muted = video.muted;
        soundBtn.classList.toggle('is-muted', muted);
        soundBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          video.muted = !video.muted;
          updateSoundState();
        });
        updateSoundState();
      }

      // Button click (when visible) — play + unmute, pause
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (video.paused) {
            video.muted = false;
            video.play();
          } else {
            video.pause();
          }
          updateSoundState();
        });
      }

      // Click anywhere on the section to toggle play/pause
      section.addEventListener('click', function () {
        if (video.paused) {
          video.muted = false;
          video.play();
        } else {
          video.pause();
        }
        updateSoundState();
      });
      section.style.cursor = 'pointer';

      video.addEventListener('play', updateState);
      video.addEventListener('pause', updateState);
      video.addEventListener('loadedmetadata', updateState);
      video.addEventListener('play', updateSoundState);
      updateState();
    });
  });
}());

// ── ADP Workforce Now widget loader ─────────────────────────────────────────
if (typeof Drupal !== 'undefined') {
  Drupal.behaviors.ciswpAdpRecruitmentLoader = {
    attach: function (context) {
      var widgets = context.querySelectorAll
        ? context.querySelectorAll('.adp-recruitment-widget:not(.is-loaded)')
        : [];

      widgets.forEach(function (widget) {
        var openings = widget.querySelector('recruitment-current-openings');
        if (!openings) return;

        var startedAt = Date.now();
        var observer;

        function hasRendered() {
          var hasLightDom = openings.children.length > 0 || openings.textContent.trim().length > 0;
          var hasShadowDom = openings.shadowRoot && openings.shadowRoot.children.length > 0;
          var grewPastPlaceholder = openings.getBoundingClientRect().height > 190;

          return hasLightDom || hasShadowDom || grewPastPlaceholder || Date.now() - startedAt > 10000;
        }

        function markLoaded() {
          if (!hasRendered()) return;

          widget.classList.add('is-loaded');
          if (observer) {
            observer.disconnect();
          }
        }

        observer = new MutationObserver(markLoaded);
        observer.observe(openings, { childList: true, subtree: true, characterData: true });

        var interval = setInterval(function () {
          markLoaded();
          if (widget.classList.contains('is-loaded')) {
            clearInterval(interval);
          }
        }, 250);
      });
    },
  };
}

// ── Job Post Modal ──────────────────────────────────────────────────────────
(function () {
  'use strict';

  var overlay, modal, titleEl, deptTag, deptName, teaserEl,
      empEl, salaryEl, locationEl, statusEl, bodyEl, readMoreEl;

  function init() {
    overlay    = document.getElementById('job-modal');
    if (!overlay) return;

    modal      = overlay.querySelector('.job-modal');
    titleEl    = overlay.querySelector('.job-modal__title');
    deptTag    = overlay.querySelector('.job-modal__dept-tag');
    deptName   = overlay.querySelector('.job-modal__dept-name');
    teaserEl   = overlay.querySelector('.job-modal__teaser');
    empEl      = overlay.querySelector('.job-modal__meta-emp');
    salaryEl   = overlay.querySelector('.job-modal__meta-salary');
    locationEl = overlay.querySelector('.job-modal__meta-location');
    statusEl   = overlay.querySelector('.job-modal__meta-status');
    bodyEl     = overlay.querySelector('.job-modal__body-text');
    readMoreEl = overlay.querySelector('.job-modal__btn--primary');

    // Open on card click
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-job-card-trigger');
      if (!trigger) return;
      e.preventDefault();
      var card = trigger.closest('.job-post-card');
      if (card) openModal(card);
    });

    // Close on button click
    overlay.addEventListener('click', function (e) {
      if (e.target.closest('.js-job-modal-close') || e.target === overlay) {
        closeModal();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function openModal(card) {
    var data = card.querySelector('.job-post-card__modal-data');

    // Populate text fields from data attributes
    titleEl.textContent    = card.dataset.title    || '';
    teaserEl.textContent   = card.dataset.teaser   || '';
    salaryEl.textContent   = card.dataset.salary   || '';
    locationEl.textContent = card.dataset.location || '';

    // Department pill
    var dept = card.dataset.department || '';
    deptName.textContent = dept;
    deptTag.style.display = dept ? '' : 'none';

    // Employment type label (strip Drupal field wrappers — get text only)
    var empNode = data ? data.querySelector('.js-emp-type-label') : null;
    empEl.textContent = empNode ? empNode.textContent.trim() : '';

    // Posting status label
    var statusNode = data ? data.querySelector('.js-status-label') : null;
    statusEl.textContent = statusNode ? statusNode.textContent.trim() : '';

    // Body HTML — injected safely from Drupal-processed text
    var bodyNode = data ? data.querySelector('.js-body-html') : null;
    bodyEl.innerHTML = bodyNode ? bodyNode.innerHTML : '';

    // Read More URL
    readMoreEl.href = card.dataset.url || '#';

    // Show modal
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Focus the modal for accessibility
    setTimeout(function () { modal.focus(); }, 50);
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', init);
}());

// Suppress Views AJAX auto-scroll. viewsScrollTop is defined by
// views/ajax_view.js. We override it via a Drupal behavior so it re-applies
// after every attachBehaviors call, without creating circular dependencies.
if (typeof Drupal !== 'undefined') {
  Drupal.behaviors.ciswpNoViewsScroll = {
    attach: function () {
      if (Drupal.AjaxCommands && Drupal.AjaxCommands.prototype.viewsScrollTop) {
        Drupal.AjaxCommands.prototype.viewsScrollTop = function () {};
      }
    },
  };
}

